<template>
    <div>
        <div class="code-container">
            <div class="basic-info">
                <div>
                    <van-image
                        round
                        width="60"
                        height="60"
                        :error-icon="userDefaultAvatar"
                        :src="userInfo.avatarUrl"
                        class="user-avatar"
                    ></van-image>
                    <span class="user-name">{{ userInfo.nickName }}</span>
                </div>
                <div class="table-wrapper">
                    <div class="table-cell-box">
                        <span class="rights-count">{{
                            userInfo.inviolableRightsFrequency
                        }}</span>
                        <span class="right-show-count">权益码展示次数</span>
                    </div>
                    <div class="table-cell-box">
                        <van-button
                            class="code-show-button"
                            @click="showRightBtn"
                            :disabled="userInfo.inviolableRightsFrequency === 0"
                            >展示权益码</van-button
                        >
                    </div>
                </div>
            </div>
            <div class="code-section">
                <div class="right-text">权益码</div>
                <div style="position: relative">
                    <span class="show-tip">请向商家展示二维码</span>
                    <button @click="goModify" class="go-back-btn">
                        重新修改上传 >
                    </button>
                </div>
                <div style="text-align: center">
                    <div class="code-wrapper">
                        <template v-if="!showCode && !flag">
                            <div class="code-mask">
                                <span>请下载APP 获得永久展示权益码</span>
                            </div>
                            <img
                                class="code-bg"
                                src="../../assets/jike/code.png"
                            />
                        </template>
                        <div v-else class="qrcode" ref="qrCodeUrl"></div>
                        <!--                        <canvas v-else class='canvas' style="width:{{qrcodeWidth}}px; height:{{qrcodeWidth}}px;" canvas-id='canvas' bindlongtap='save'></canvas>-->
                    </div>
                    <div class="product-name">{{ productName }}</div>
                </div>
            </div>
        </div>
        <div class="btn-container">
            <van-button
                style="width: 100%"
                @click="onDownLoad"
                class="get-profit-btn"
                >下载窝窝投App</van-button
            >
        </div>
    </div>
</template>
<style lang="less" scoped>
.code-container {
    padding: 15px;
    margin-bottom: 70px;

    .user-avatar {
        //width: 50px;
        //height: 50px;
        //border-radius: 50%;
        vertical-align: middle;
        margin-right: 15px;
    }

    .user-name {
        color: #171f24;
        font-size: 17px;
    }

    .table-wrapper {
        display: flex;
        padding: 30px 0;
        border-bottom: 1px solid #eeeeee;
        align-items: center;

        .table-cell-box {
            text-align: center;
            flex: 1;

            span {
                text-align: center;
                display: block;
                line-height: 35px;
            }

            .code-show-button {
                color: white;
                display: inline-block;
                font-size: 13px;
                width: 100px;
                border-radius: 3px;
                height: 26px;
                background: linear-gradient(180deg, #17c1ce 0%, #17ce92 100%);

                /* display: block; */
                &[disabled]:not([type]) {
                    background: #676665;
                    color: #ffffff;
                }
            }

            .rights-count {
                color: #f42020;
            }

            .right-show-count {
                font-size: 12px;
            }
        }
    }

    .code-section {
        padding: 20px 0;

        .right-text {
            font-weight: bold;
            font-size: 21px;
        }

        .show-tip {
            margin-top: 8px;
            color: #f42020;
            font-size: 12px;
            background: rgba(244, 32, 32, 0.15);
            display: inline-block;
            padding: 2px 10px;
            border-radius: 2px;
        }
    }

    .code-wrapper {
        position: relative;
        display: inline-block;
        margin: 40px auto 5px;

        .code-mask {
            z-index: 10;
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.83);
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                color: white;
                font-size: 15px;
                line-height: 25px;
                opacity: 0.83;
            }
        }

        .code-bg {
            width: 150px;
            height: 150px;
        }
    }
}

.btn-container {
    position: fixed;
    box-shadow: 0px -2px 4px 0px rgba(2, 4, 51, 0.08);
    bottom: 0;
    padding: 15px;
    width: 100%;
    box-sizing: border-box;

    button {
        height: 50px;
        background: linear-gradient(180deg, #17c1ce 0%, #17ce92 100%);
        color: white;
        font-size: 16px;
        line-height: 50px;
    }
}

.go-back-btn {
    border: none;
    display: inline;
    position: absolute;
    right: 0;
    top: -30px;
    background: #ffffff;
    font-size: 12px;

    &::after {
        border: none;
    }
}

.product-name {
    padding-bottom: 30px;
}
</style>
<script>
import QRCode from "qrcodejs2";
import { Notify } from "vant";
import { getInfo, getRightInfo, reduceRight } from "../../services/taskDetail";

export default {
    data() {
        return {
            taskId: "",
            userDefaultAvatar: require("../../assets/user.png"),
            taskApplyId: "",
            userInfo: {
                inviolableRightsFrequency: 0,
            },
            text: "",
            image: "",
            // 用于设置wxml里canvas的width和height样式
            // qrcodeWidth: qrcodeWidth,
            imgsrc: "",
            showCode: false,
            flag: 0, // 是否展示权益码（路径参数）
            productName: "", // 商品名称（路径参数）
            qrcode: null,
        };
    },
    mounted() {
        const options = this.$route.query;
        this.taskId = options.taskId;
        this.taskApplyId = options.id;
        this.productName = options.name;
        this.handleGetUserInfo();
        if (options.flag === "1") {
            this.flag = Number(options.flag);
            this.renderCode();
        }
    },
    methods: {
        renderCode() {
            this.showCode = true;
            const that = this;
            this.$nextTick(() => {
                const host = "http://192.168.3.110:10291";
                const value = `${host}/profitCancel/${this.taskApplyId}`;
                this.qrcode = new QRCode(that.$refs.qrCodeUrl, {
                    text: value, // 需要转换为二维码的内容
                    width: 150,
                    height: 150,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H,
                });
            });
        },
        handleGetUserInfo() {
            getInfo()
                .then((res) => {
                    console.log(res);
                    res.avatarUrl = `https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${res.avatarUrl}`;
                    this.userInfo = res;
                    // 查询子任务详情获取（是否展示权益码（options传递）/任务？商品（再加一个接口）名称）
                })
                .catch(() => {});
        },
        // 去修改页面
        goModify() {
            getRightInfo(this.taskApplyId).then((res) => {
                console.log(res);
                if (res.status.value === 100) {
                    Notify({ type: "warning", message: "该任务已核销" });
                } else {
                    this.$router.push(`/instantTaskDetail?id=${this.taskId}`);
                    this.$eventBus.$emit("switchModify");
                }
            });
        },
        showRightBtn() {
            reduceRight(this.taskApplyId).then((res) => {
                console.log(res);
                // 消耗权益码次数后展示权益码， 同时手动更新剩余次数, 处罚详情页的applyData更新下次进入的flag
                this.userInfo = {
                    ...this.userInfo,
                    inviolableRightsFrequency: 0,
                };
                this.renderCode();
                this.$eventBus.$emit("refresh_task_apply");
            });
        },
        onDownLoad() {
            this.$router.push("/download");
        },
    },
};
</script>
